import getExtendedFields from "testUtils/mockData/signuplist/6/getextendedfields";

const mockResponses = {
  getExtendedFields,
};

export default mockResponses;
